<template>
  <div class="metric-cell">
    <template v-if="hasData">
      <strong
        class="metric-cell__value"
        :class="{ 'metric-cell__value--link': clickable }"
        @click="emitDetail"
        >{{ formattedValue }}</strong
      >
      <span class="metric-cell__weight">ponderación {{ formattedWeight }}%</span>
    </template>
    <span v-else class="metric-cell__empty">{{ emptyLabel }}</span>
  </div>
</template>

<script>
const METRIC_INCIDENTS = 'incidents';
const METRIC_RATING = 'rating';
const RATING_SCALE_MAX = 5;
const DECIMALS = 2;
const NO_ORDERS = 0;

const METRIC_FIELDS = {
  incidents: { score: 'incident_score', weight: 'incident_weight', value: 'incident_ratio' },
  availability: {
    score: 'availability_score',
    weight: 'availability_weight',
    value: 'availability_pct'
  },
  active_menu: { score: 'active_menu_score', weight: 'active_menu_weight', value: 'active_menu_pct' },
  rating: { score: 'rating_score', weight: 'rating_weight', value: 'rating_average' }
};

export default {
  name: 'LevelMetricCell',
  props: {
    metric: { type: String, required: true },
    period: { type: Object, required: true },
    threshold: { type: Object, default: null },
    clickable: { type: Boolean, default: false }
  },
  computed: {
    fields() {
      return METRIC_FIELDS[this.metric] || null;
    },
    hasData() {
      if (!this.fields) {
        return false;
      }

      const score = this.period[this.fields.score];

      return score !== null && score !== undefined;
    },
    belowMinimumSample() {
      if (!this.threshold || this.threshold.minimum_sample === null) {
        return false;
      }

      return Number(this.period.rating_count) < Number(this.threshold.minimum_sample);
    },
    emptyLabel() {
      if (Number(this.period.orders_count) === NO_ORDERS) {
        return 'sin pedidos';
      }
      if (this.metric === METRIC_RATING && this.belowMinimumSample) {
        return 'sin reseñas suficientes';
      }

      return 'sin datos';
    },
    formattedValue() {
      const value = this.toFixed(this.period[this.fields.value]);

      if (this.metric === METRIC_INCIDENTS) {
        return `${value} gravedad/pedido`;
      }
      if (this.metric === METRIC_RATING) {
        return `${value} / ${RATING_SCALE_MAX}`;
      }

      return `${value}%`;
    },
    formattedWeight() {
      return this.toFixed(this.period[this.fields.weight]);
    }
  },
  methods: {
    toFixed(value) {
      return Number(value).toFixed(DECIMALS);
    },
    emitDetail() {
      if (this.clickable) {
        this.$emit('detail');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.metric-cell {
  display: flex;
  flex-direction: column;
  line-height: 1.35;
}
.metric-cell__value {
  font-size: 0.85rem;
}
.metric-cell__value--link {
  cursor: pointer;
  text-decoration: underline;
}
.metric-cell__weight {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #8a988f;
}
.metric-cell__empty {
  font-size: 0.75rem;
  font-style: italic;
  color: #8a988f;
}
</style>
